import React from 'react';
import { Specifications } from '../../../../_metronic/layout/components/basePage/insidePages/Specifications';
import { SpecificationsUIProvider } from '../../../../_metronic/layout/components/basePage/insidePages/SpecificationsUIContext';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';
import { sortCaret } from '../../../../_metronic/_helpers';
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/insidePages/column-formatters";


const init = {
    id: undefined,
    auditPeriodId: 0,
    auditPeriodTitle: "",
    formTypeId: 0,
    title: "",
    allowed: true,
    categoryId: 0,
    isDeleted: false,
};

const columns = [
    {
        dataField: "auditPeriodTitle",
        text: "دوره",
        sort: true,
        sortCaret: sortCaret,
    },
    {
        dataField: "title",
        text: "نوع پرسشنامه ",
        sort: false,
        sortCaret: sortCaret,
    },
    {
        dataField: "allowed",
        text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
        // text: "وضعیت",
        sort: true,
        sortCaret: sortCaret,
        formatter: columnFormatters.AllowedColumnFormatter,
    },
];


export const prepareFilter = (queryParams, values) => {
    const { allowed, auditPeriodId, formTypeId } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    // filter.allowed = allowed !== "" ? +allowed : undefined;
    // filter.auditPeriodId = auditPeriodId !== "" ? +auditPeriodId : 0;
    // filter.formTypeId = formTypeId !== "" ? +formTypeId : 0;


    // // // Filter by all fields
    // // filter.title = searchText;
    // // if (searchText) {
    // //     filter.title = searchText;
    // // }
    // newQueryParams.filter = filter;

    // // let whereClause = "title.contains(@0)"
    // let whereClause = ""
    // const whereClauseParameters = [];
    // // whereClauseParameters.push(searchText)

    // // whereClause = whereClause + "isDeleted=@0"
    // // whereClauseParameters.push(false)

    // if (filter.auditPeriodId > 0) {
    //     whereClause = whereClause + "auditPeriodId=@0"
    //     whereClauseParameters.push(filter.auditPeriodId)
    // }
    // else {
    //     whereClause = whereClause + "auditPeriodId!=@0"
    //     whereClauseParameters.push(0)
    // }

    // if (filter.formTypeId > 0) {
    //     whereClause = whereClause + " and formTypeId=@1"
    //     whereClauseParameters.push(filter.formTypeId)
    // }
    // else {
    //     whereClause = whereClause + " and formTypeId!=@1"
    //     whereClauseParameters.push(0)
    // }

    // newQueryParams.whereClause = whereClause;
    // newQueryParams.whereClauseParameters = whereClauseParameters;


    return newQueryParams;
};

export const filterInitialValues = {
    filter: {
        searchText: "",
        auditPeriodId: 0
    },
    sortOrder: "asc", // asc||desc
    sortField: "id",
    pageNumber: 1,
    pageSize: 10,

    whereClause: "",
    whereClauseParameters: [
    ],
    orderClause: "id desc ",
    skipCount: 0,
    takeCount: 10,
};
export const filterFields = [
    // {
    //     name: "formTypeId",
    //     lable: "نوع پرسشنامه ",
    //     type: "component",
    //     list: [],
    //     component: (props) =>
    //         <SelectObjectsField api="api/FormType"
    //             reduxState="formTypes"
    //             sname="formTypeId"
    //             {...props} />
    // },
];

export const FormTypeAccessPage = ({ id }) => {
    return (
        <FilterObjectsUIProvider initialFilter={filterInitialValues}>
            <SpecificationsUIProvider currentParentId={id} currentParentName="auditPeriodId" initSpecification={init}>
                <Specifications currentParentId={id} api="api/AuditFormType" reduxName="auditFormTypes" columns={columns} prepareFilter={prepareFilter}
                    filterInitialValues={filterInitialValues} filterFields={filterFields} haveFullAccess={false} />
            </SpecificationsUIProvider>
        </FilterObjectsUIProvider>
    )
}




